(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/default-promo-info-bar-users.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/default-promo-info-bar-users.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.default_promo_info_bar_users = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "    <i class=\"icon-default icon-singleplayer icon-100\"></i>\n    <span class=\"align-middle\">Singelbingo</span>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <i class=\"icon-default icon-multiplayer icon-100\"></i>\n    <span class=\"align-middle\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoBar") : depth0)) != null ? lookupProperty(stack1,"attributes") : stack1)) != null ? lookupProperty(stack1,"users") : stack1), depth0))
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"rounds-header-column\">\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"playmode") : depth0),"===","SINGLEUSER",{"name":"compare","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":8,"column":14}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});
Handlebars.partials['components-app-product_start_page-default_promo_info_bar_users'] = svs.app.product_start_page.templates.default_promo_info_bar_users;
})(svs, Handlebars);


 })(window);